import { useEffect } from "react";

export default function useOutsideDetector(ref, onOutsideClick = (event) => {}) {
     useEffect(() => {
          function handleClickOutside(event) {
               if (ref.current && !ref.current.contains(event.target) && !(document.getElementById('win-keyboard') && document.getElementById('win-keyboard').contains(event.target))) {
                    onOutsideClick(event);
               }
          }
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
               document.removeEventListener("mousedown", handleClickOutside);
          };
     }, [ref]);
}